import { ThunkAction } from 'redux-thunk';
import { Action } from 'redux';
import ApiRequest from 'client/helpers/apiRequest';
import { Event } from 'client/types/event';
import { List } from 'client/types/common';
import { ApiFilters } from 'client/types/filters';
import * as actions from './actions';

interface Params {
    filters?: ApiFilters;
    pageNumber?: number;
    pageSize?: number;
}

export const fetchEvents = (params: Params = {}): ThunkAction<any, any, null, Action<string>> => dispatch => {
    const { pageNumber, pageSize = 8, filters } = params;

    dispatch(actions.fetchEventsRequest(pageNumber));

    const query = {
        pageNumber,
        pageSize,
        filters: JSON.stringify(filters)
    };

    return ApiRequest.get<List<Event>>('/api/events', { params: query }).then(
        response => dispatch(actions.fetchEventsSuccess(response)),
        error => {
            console.warn(error);

            return dispatch(actions.fetchEventsError(error));
        }
    );
};
